import { render, staticRenderFns } from "./CancellationReasonsTab.vue?vue&type=template&id=f58d071a"
import script from "./CancellationReasonsTab.vue?vue&type=script&lang=ts"
export * from "./CancellationReasonsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports